import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import dayjs from 'dayjs';
import { sequences, state } from 'app/pwa/app.cerebral';

import Leaderboard from '../../components/Leaderboard';
import LeaderboardFooter from '../LeaderboardFooter';

import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

import { UpdateWrapper, UpdateText, UpdateButton } from './elements';

const deps = {
  leaderboard: state.challenge.visualisations.computedLeaderboardChampionship,
  lastUpdated:
    state.challenge.visualisations.championshipLeaderboardLastUpdated,
  updateChampionshipLeaderboardClicked: sequences`challenge.visualisations.updateChampionshipLeaderboardClicked`,
};

function LeaderboardChampionship({
  leaderboard,
  lastUpdated,
  updateChampionshipLeaderboardClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <>
      <UpdateWrapper>
        <UpdateText>
          {t(`challenge.toplist.lists.championship.last_updated`, {
            lastUpdated: dayjs(lastUpdated).fromNow(),
          })}
        </UpdateText>
        <UpdateButton
          onClick={() => updateChampionshipLeaderboardClicked()}
          icon={ICON.refresh}
        />
      </UpdateWrapper>
      <Leaderboard
        title={t(`challenge.toplist.lists.championship.you`)}
        leaderboard={leaderboard.short}
      />

      <Leaderboard
        title={t(`challenge.toplist.lists.championship.all`)}
        leaderboard={leaderboard.long}
      />
      <LeaderboardFooter
        currentPage={leaderboard.currentPage}
        pageCount={leaderboard.pageCount}
      />
    </>
  );
}

export default connect(deps, LeaderboardChampionship);
